import React, { useState } from "react"; 
import { apibaseurl } from "../../../../core/webservice/Webservice_url";

type AddressDetailsViewProps = {
  data: any[];
};

const fileUrl = (path?: string | null) => (path ? `${apibaseurl}${path}` : "");

const getInitials = (name?: string | null) =>
  (name || "")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase())
    .join("") || "?";

const AddressDetailsView = ({ data }: AddressDetailsViewProps) => {
  const [preview, setPreview] = useState<{ url: string; label: string } | null>(
    null,
  );

  if (!data || data.length === 0) {
    return (
      <div className="card-body text-center py-5">
        <i
          className="ti ti-map-pin-off text-secondary"
          style={{ fontSize: 48 }}
        ></i>
        <h6 className="mt-3 mb-1">No Details Found</h6>
        <p className="text-muted mb-0">
          The candidate has not submitted any address information yet.
        </p>
      </div>
    );
  }

  return (
    <div className="card-body">
      <style>{`
        .adv-card {
          background: #fff;
          border: 1px solid #F1F1F4;
          border-radius: 18px;
          box-shadow: 0 4px 20px rgba(17, 24, 39, .05);
          height: 100%;
          overflow: hidden;
        }
        .adv-card-head {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 16px 20px;
          border-bottom: 1px solid #F3F4F6;
          background: linear-gradient(135deg, #FFF8F0 0%, #FFFFFF 100%);
        }
        .adv-head-icon {
          width: 38px;
          height: 38px;
          border-radius: 12px;
          background: #E67E22;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 19px;
          flex-shrink: 0;
        }
        .adv-address-box {
          position: relative;
          padding: 15px 18px 15px 22px;
          border-radius: 14px;
          background: #FFF8F0;
          border: 1px solid #FFE3C7;
        }
        .adv-address-box::before {
          content: "";
          position: absolute;
          left: 0;
          top: 12px;
          bottom: 12px;
          width: 4px;
          border-radius: 4px;
          background: #E67E22;
        }
        .adv-mini {
          background: #F9FAFB;
          border: 1px solid #F1F1F4;
          border-radius: 14px;
          padding: 12px 14px;
          height: 100%;
          transition: border-color .2s ease, transform .2s ease;
        }
        .adv-mini:hover {
          border-color: #F4B183;
          transform: translateY(-2px);
        }
        .adv-label {
          font-size: 11px;
          font-weight: 600;
          letter-spacing: .6px;
          text-transform: uppercase;
          color: #9CA3AF;
          margin-bottom: 2px;
        }
        .adv-value {
          font-weight: 700;
          color: #111827;
          word-break: break-word;
        }
        .adv-stat {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 14px;
          border-radius: 14px;
          background: #F9FAFB;
          border: 1px solid #F1F1F4;
        }
        .adv-stat-icon {
          width: 46px;
          height: 46px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          flex-shrink: 0;
        }
        .adv-avatar {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          background: linear-gradient(135deg, #E67E22, #F4B183);
          color: #fff;
          font-weight: 700;
          font-size: 22px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 6px 16px rgba(230, 126, 34, .35);
        }
        .adv-photo {
          position: relative;
          height: 210px;
          border-radius: 16px;
          overflow: hidden;
          background: #F3F4F6;
          cursor: pointer;
          box-shadow: 0 4px 16px rgba(17, 24, 39, .08);
          transition: transform .25s ease, box-shadow .25s ease;
        }
        .adv-photo:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 28px rgba(17, 24, 39, .18);
        }
        .adv-photo img {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform .35s ease;
        }
        .adv-photo:hover img {
          transform: scale(1.08);
        }
        .adv-photo-fallback {
          position: absolute;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #D1D5DB;
          font-size: 42px;
        }
        .adv-photo-shade {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          padding: 40px 14px 12px;
          background: linear-gradient(to top, rgba(0,0,0,.72), transparent);
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;
        }
        .adv-photo-eye {
          position: absolute;
          top: 12px;
          right: 12px;
          width: 34px;
          height: 34px;
          border-radius: 50%;
          background: rgba(255,255,255,.92);
          color: #111827;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transform: scale(.85);
          transition: all .2s ease;
        }
        .adv-photo:hover .adv-photo-eye {
          opacity: 1;
          transform: scale(1);
        }
        .adv-lightbox {
          position: fixed;
          inset: 0;
          z-index: 2000;
          background: rgba(0,0,0,.82);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 24px;
        }
        .adv-lightbox img {
          max-width: 92vw;
          max-height: 80vh;
          border-radius: 14px;
          box-shadow: 0 20px 60px rgba(0,0,0,.5);
          background: #fff;
        }
        .adv-lightbox-close {
          position: absolute;
          top: 20px;
          right: 24px;
          width: 42px;
          height: 42px;
          border-radius: 50%;
          border: 0;
          background: #fff;
          color: #111827;
          font-size: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      `}</style>

      {data.map((address: any) => {
        const photos = [
          {
            key: "live_selfie_url",
            label: "Live Selfie",
            icon: "ti ti-camera",
            url: address.live_selfie_url,
            verified: address.live_selfie_verified,
          },
          {
            key: "id_proof_photo",
            label: "ID Proof",
            icon: "ti ti-id",
            url: address.id_proof_photo,
          },
          {
            key: "address_proof_photo",
            label: "Address Proof",
            icon: "ti ti-file-certificate",
            url: address.address_proof_photo,
          },
          {
            key: "house_photo",
            label: "House Photo",
            icon: "ti ti-home",
            url: address.house_photo,
          },
          {
            key: "locality_photo",
            label: "Locality Photo",
            icon: "ti ti-building-community",
            url: address.locality_photo,
          },
          {
            key: "digital_signature_url",
            label: "Digital Signature",
            icon: "ti ti-signature",
            url: address.digital_signature_url,
          },
        ].filter((p) => p.url);

        const fullAddress = [
          address.address_line1,
          address.address_line2,
          address.address_line3,
        ]
          .filter(Boolean)
          .join(", ");

        const mapsLink =
          address.address_latitude && address.address_longitude
            ? `https://www.google.com/maps?q=${address.address_latitude},${address.address_longitude}`
            : "";

        const coordinates =
          address.address_latitude && address.address_longitude
            ? `${Number(address.address_latitude).toFixed(5)}, ${Number(
                address.address_longitude,
              ).toFixed(5)}`
            : "—";

        const stay = address.period_of_stay
          ? `${address.period_of_stay} ${address.period_of_stay_param || ""}`
          : "—";

        return (
          <div key={address.address_id} className="mb-4">
            <div className="row g-4 mb-4">
              {/* ================= Address Details ================= */}
              <div className="col-lg-8">
                <div className="adv-card">
                  <div className="adv-card-head">
                    <div className="adv-head-icon">
                      <i className="ti ti-map-pin"></i>
                    </div>
                    <div>
                      <h6 className="fw-bold mb-0">Address Details</h6>
                      <small className="text-muted">
                        Location submitted by the candidate
                      </small>
                    </div>
                  </div>

                  <div className="p-3 p-md-4">
                    {/* Full address */}
                    <div className="adv-address-box mb-4">
                      <div className="adv-label">Full Address</div>
                      <div
                        className="fw-bold text-dark"
                        style={{ fontSize: 14, lineHeight: 1.5 }}
                      >
                        {fullAddress || "—"}
                      </div>
                    </div>

                    {/* City / State / Pincode / Country */}
                    <div className="row g-3 mb-4">
                      {[
                        {
                          icon: "ti ti-building",
                          label: "City",
                          value: address.city,
                        },
                        {
                          icon: "ti ti-map",
                          label: "State",
                          value: address.state,
                        },
                        {
                          icon: "ti ti-mailbox",
                          label: "Pincode",
                          value: address.pincode,
                        },
                        {
                          icon: "ti ti-world",
                          label: "Country",
                          value: address.country,
                        },
                      ].map((item) => (
                        <div className="col-md-3 col-6" key={item.label}>
                          <div className="adv-mini">
                            <div className="adv-label">
                              <i
                                className={`${item.icon} me-1`}
                                style={{ color: "#E67E22" }}
                              ></i>
                              {item.label}
                            </div>
                            <div className="adv-value">{item.value || "—"}</div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Resolved location + coordinates + map */}
                    <div
                      className="d-flex flex-wrap align-items-center justify-content-between gap-3 p-3"
                      style={{
                        borderRadius: 14,
                        background: "#F9FAFB",
                        border: "1px dashed #F4B183",
                      }}
                    >
                      <div className="d-flex align-items-center gap-3">
                        <div
                          className="adv-stat-icon"
                          style={{ background: "#FFF3E6", color: "#E67E22" }}
                        >
                          <i className="ti ti-current-location"></i>
                        </div>
                        <div>
                          <div className="adv-label mb-0">Resolved Location</div>
                          <div className="adv-value">
                            {address.resolved_address || "—"}
                          </div>
                          <small className="text-muted">
                            <i className="ti ti-map-pin-2 me-1"></i>
                            {coordinates}
                          </small>
                        </div>
                      </div>

                      {mapsLink && (
                        <a
                          href={mapsLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-primary btn-sm px-3"
                        >
                          <i className="ti ti-map-2 me-1"></i>
                          View on Map
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* ================= Stay + Verifier ================= */}
              <div className="col-lg-4">
                <div className="d-flex flex-column gap-4 h-100">
                  {/* Stay details */}
                  <div className="adv-card" style={{ height: "auto" }}>
                    <div className="adv-card-head">
                      <div
                        className="adv-head-icon"
                        style={{ background: "#0EA5E9" }}
                      >
                        <i className="ti ti-home-check"></i>
                      </div>
                      <h6 className="fw-bold mb-0">Stay Details</h6>
                    </div>

                    <div className="p-3 d-flex flex-column gap-3">
                      <div className="adv-stat">
                        <div
                          className="adv-stat-icon"
                          style={{ background: "#E0F2FE", color: "#0284C7" }}
                        >
                          <i className="ti ti-calendar-time"></i>
                        </div>
                        <div>
                          <div className="adv-label mb-0">Period of Stay</div>
                          <div className="adv-value" style={{ fontSize: 18 }}>
                            {stay}
                          </div>
                        </div>
                      </div>

                      <div className="adv-stat">
                        <div
                          className="adv-stat-icon"
                          style={{ background: "#DCFCE7", color: "#16A34A" }}
                        >
                          <i className="ti ti-key"></i>
                        </div>
                        <div>
                          <div className="adv-label mb-0">Ownership Status</div>
                          <div className="adv-value" style={{ fontSize: 18 }}>
                            {address.ownership_status || "—"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Verifier */}
                  <div className="adv-card flex-grow-1">
                    <div className="adv-card-head">
                      <div
                        className="adv-head-icon"
                        style={{ background: "#8B5CF6" }}
                      >
                        <i className="ti ti-user-check"></i>
                      </div>
                      <h6 className="fw-bold mb-0">Verifier</h6>
                    </div>

                    <div className="p-3">
                      <div className="d-flex align-items-center gap-3 mb-3">
                        <div className="adv-avatar">
                          {getInitials(address.verifier_full_name)}
                        </div>
                        <div style={{ minWidth: 0 }}>
                          <div
                            className="fw-bold text-dark"
                            style={{ fontSize: 17 }}
                          >
                            {address.verifier_full_name || "—"}
                          </div>
                          {address.verifier_relationship && (
                            <span
                              className="badge rounded-pill mt-1"
                              style={{
                                background: "#EDE9FE",
                                color: "#6D28D9",
                                fontWeight: 600,
                              }}
                            >
                              {address.verifier_relationship}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="adv-mini">
                        <div className="adv-label">
                          <i
                            className="ti ti-flag me-1"
                            style={{ color: "#E67E22" }}
                          ></i>
                          Landmark
                        </div>
                        <div className="adv-value">
                          {address.verifier_addrlandmark || "Not provided"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ================= Photos ================= */}
            <div className="adv-card" style={{ height: "auto" }}>
              <div className="adv-card-head">
                <div
                  className="adv-head-icon"
                  style={{ background: "#EC4899" }}
                >
                  <i className="ti ti-photo"></i>
                </div>
                <div className="flex-grow-1">
                  <h6 className="fw-bold mb-0">Selfie & Uploaded Photos</h6>
                  <small className="text-muted">
                    Click any photo to view it larger
                  </small>
                </div>
                <span
                  className="badge rounded-pill px-3 py-2"
                  style={{ background: "#FCE7F3", color: "#BE185D" }}
                >
                  {photos.length} {photos.length === 1 ? "file" : "files"}
                </span>
              </div>

              <div className="p-3 p-md-4">
                {photos.length > 0 ? (
                  <div className="row g-4">
                    {photos.map((photo) => (
                      <div
                        className="col-xl-3 col-lg-4 col-md-6"
                        key={photo.key}
                      >
                        <div
                          className="adv-photo"
                          onClick={() =>
                            setPreview({
                              url: fileUrl(photo.url),
                              label: photo.label,
                            })
                          }
                        >
                          <div className="adv-photo-fallback">
                            <i className={photo.icon}></i>
                          </div>

                          <img
                            src={fileUrl(photo.url)}
                            alt={photo.label}
                            onError={(e) => {
                              e.currentTarget.style.display = "none";
                            }}
                          />

                          <div className="adv-photo-eye">
                            <i className="ti ti-eye"></i>
                          </div>

                          <div className="adv-photo-shade">
                            <div className="d-flex align-items-center gap-2">
                              <i className={photo.icon}></i>
                              <span className="fw-semibold">{photo.label}</span>
                            </div>

                            {photo.key === "live_selfie_url" && (
                              <span
                                className="badge"
                                style={{
                                  background: photo.verified
                                    ? "#22C55E"
                                    : "#EF4444",
                                }}
                              >
                                <i
                                  className={`ti ${
                                    photo.verified ? "ti-circle-check" : "ti-x"
                                  } me-1`}
                                ></i>
                                {photo.verified ? "Verified" : "Not Verified"}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center text-muted py-4">
                    <i className="ti ti-photo-off fs-1 d-block mb-2"></i>
                    No photos uploaded.
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}

      {/* ================= Lightbox ================= */}
      {preview && (
        <div className="adv-lightbox" onClick={() => setPreview(null)}>
          <button
            type="button"
            className="adv-lightbox-close"
            onClick={() => setPreview(null)}
            aria-label="Close preview"
          >
            <i className="ti ti-x"></i>
          </button>

          <img
            src={preview.url}
            alt={preview.label}
            onClick={(e) => e.stopPropagation()}
          />

          <div className="text-white fw-semibold mt-3">{preview.label}</div>
        </div>
      )}
    </div>
  );
};

export default AddressDetailsView;


// import React from "react";
// import { apibaseurl } from "../../../core/webservice/Webservice_url";
// import { formatDate } from "../../../core/common/TabelValue";

// type AddressDetailsViewProps = {
//   data: any[];
// };

// const fileUrl = (path?: string | null) => (path ? `${apibaseurl}${path}` : "");

// const prettify = (text?: string | null) =>
//   text
//     ? text
//         .replace(/_/g, " ")
//         .toLowerCase()
//         .replace(/\b\w/g, (c) => c.toUpperCase())
//     : "-";

// const statusClass = (status?: string) => {
//   switch (status) {
//     case "CANDIDATE_SUBMITTED":
//       return "bg-info-subtle text-info-emphasis border border-info-subtle";
//     case "VERIFIED":
//     case "COMPLETED":
//       return "bg-success-subtle text-success-emphasis border border-success-subtle";
//     case "REJECTED":
//       return "bg-danger-subtle text-danger-emphasis border border-danger-subtle";
//     default:
//       return "bg-warning-subtle text-warning-emphasis border border-warning-subtle";
//   }
// };

// const InfoItem = ({
//   icon,
//   label,
//   value,
// }: {
//   icon: string;
//   label: string;
//   value?: React.ReactNode;
// }) => (
//   <div className="d-flex align-items-start gap-3 h-100">
//     <div
//       className="d-flex align-items-center justify-content-center flex-shrink-0"
//       style={{
//         width: 40,
//         height: 40,
//         borderRadius: 12,
//         background: "#FFF3E6",
//         color: "#E67E22",
//         fontSize: 18,
//       }}
//     >
//       <i className={icon}></i>
//     </div>
//     <div style={{ minWidth: 0 }}>
//       <div
//         className="text-muted text-uppercase"
//         style={{ fontSize: 11, letterSpacing: ".5px", fontWeight: 600 }}
//       >
//         {label}
//       </div>
//       <div
//         className="fw-semibold text-dark"
//         style={{ wordBreak: "break-word" }}
//       >
//         {value || value === 0 ? value : "—"}
//       </div>
//     </div>
//   </div>
// );

// const SectionTitle = ({ icon, title }: { icon: string; title: string }) => (
//   <div className="d-flex align-items-center gap-2 mb-3">
//     <i className={icon} style={{ color: "#E67E22", fontSize: 20 }}></i>
//     <h6 className="fw-bold mb-0">{title}</h6>
//     <div className="flex-grow-1 border-top ms-2" style={{ opacity: 0.6 }} />
//   </div>
// );

// const AddressDetailsView = ({ data }: AddressDetailsViewProps) => {
//   if (!data || data.length === 0) {
//     return (
//       <div className="card-body text-center py-5">
//         <i
//           className="ti ti-map-pin-off text-secondary"
//           style={{ fontSize: 48 }}
//         ></i>
//         <h6 className="mt-3 mb-1">No Details Found</h6>
//         <p className="text-muted mb-0">
//           The candidate has not submitted any address information yet.
//         </p>
//       </div>
//     );
//   }

//   return (
//     <div className="card-body">
//       <style>{`
//         .addr-photo-card {
//           border: 1px solid #E5E7EB;
//           border-radius: 14px;
//           overflow: hidden;
//           background: #fff;
//           transition: transform .2s ease, box-shadow .2s ease;
//           height: 100%;
//         }
//         .addr-photo-card:hover {
//           transform: translateY(-4px);
//           box-shadow: 0 10px 24px rgba(0,0,0,.12);
//         }
//         .addr-photo-card .photo-wrap {
//           height: 170px;
//           background: #F3F4F6;
//           overflow: hidden;
//           cursor: pointer;
//           position: relative;
//         }
//         .addr-photo-card .photo-wrap img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           transition: transform .3s ease;
//         }
//         .addr-photo-card:hover .photo-wrap img {
//           transform: scale(1.06);
//         }
//         .addr-photo-card .photo-overlay {
//           position: absolute;
//           inset: 0;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background: rgba(0,0,0,.35);
//           color: #fff;
//           font-size: 26px;
//           opacity: 0;
//           transition: opacity .2s ease;
//         }
//         .addr-photo-card:hover .photo-overlay {
//           opacity: 1;
//         }
//       `}</style>

//       {data.map((address: any) => {
//         const photos = [
//           {
//             key: "live_selfie_url",
//             label: "Live Selfie",
//             icon: "ti ti-camera",
//             url: address.live_selfie_url,
//             verified: address.live_selfie_verified,
//           },
//           {
//             key: "id_proof_photo",
//             label: "ID Proof",
//             icon: "ti ti-id",
//             url: address.id_proof_photo,
//           },
//           {
//             key: "address_proof_photo",
//             label: "Address Proof",
//             icon: "ti ti-file-certificate",
//             url: address.address_proof_photo,
//           },
//           {
//             key: "house_photo",
//             label: "House Photo",
//             icon: "ti ti-home",
//             url: address.house_photo,
//           },
//           {
//             key: "locality_photo",
//             label: "Locality Photo",
//             icon: "ti ti-building-community",
//             url: address.locality_photo,
//           },
//           {
//             key: "digital_signature_url",
//             label: "Digital Signature",
//             icon: "ti ti-signature",
//             url: address.digital_signature_url,
//           },
//         ].filter((p) => p.url);

//         const fullAddress = [
//           address.address_line1,
//           address.address_line2,
//           address.address_line3,
//         ]
//           .filter(Boolean)
//           .join(", ");

//         const mapsLink =
//           address.address_latitude && address.address_longitude
//             ? `https://www.google.com/maps?q=${address.address_latitude},${address.address_longitude}`
//             : "";

//         return (
//           <div
//             key={address.address_id}
//             className="mb-4"
//             style={{
//               border: "1px solid #FFD8B5",
//               borderRadius: 16,
//               overflow: "hidden",
//             }}
//           >
//             <div className="p-3 p-md-4">
//               {/* Address details */}
//               <SectionTitle icon="ti ti-map-2" title="Address Details" />

//               <div
//                 className="d-flex gap-3 p-3 mb-4"
//                 style={{
//                   background: "#F9FAFB",
//                   borderRadius: 12,
//                   border: "1px dashed #F4B183",
//                 }}
//               >
//                 <i
//                   className="ti ti-map-pin fs-3 flex-shrink-0"
//                   style={{ color: "#E67E22" }}
//                 ></i>
//                 <div className="flex-grow-1">
//                   <div className="fw-semibold text-dark">
//                     {fullAddress || "—"}
//                   </div>
//                   <div className="text-muted small mt-1">
//                     {[address.city, address.state, address.pincode]
//                       .filter(Boolean)
//                       .join(", ")}
//                     {address.country ? ` - ${address.country}` : ""}
//                   </div>
//                 </div>

//                 {mapsLink && (
//                   <a
//                     href={mapsLink}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="btn btn-sm btn-outline-primary align-self-center flex-shrink-0"
//                   >
//                     <i className="ti ti-external-link me-1"></i>
//                     View on Map
//                   </a>
//                 )}
//               </div>

//               <div className="row g-4 mb-4">
//                 <div className="col-md-3 col-6">
//                   <InfoItem
//                     icon="ti ti-building"
//                     label="City"
//                     value={address.city}
//                   />
//                 </div>
//                 <div className="col-md-3 col-6">
//                   <InfoItem
//                     icon="ti ti-map"
//                     label="State"
//                     value={address.state}
//                   />
//                 </div>
//                 <div className="col-md-3 col-6">
//                   <InfoItem
//                     icon="ti ti-mailbox"
//                     label="Pincode"
//                     value={address.pincode}
//                   />
//                 </div>
//                 <div className="col-md-3 col-6">
//                   <InfoItem
//                     icon="ti ti-world"
//                     label="Country"
//                     value={address.country}
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <InfoItem
//                     icon="ti ti-current-location"
//                     label="Resolved Location"
//                     value={address.resolved_address}
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <InfoItem
//                     icon="ti ti-map-pin-2"
//                     label="Coordinates"
//                     value={
//                       address.address_latitude && address.address_longitude
//                         ? `${Number(address.address_latitude).toFixed(5)}, ${Number(
//                             address.address_longitude,
//                           ).toFixed(5)}`
//                         : ""
//                     }
//                   />
//                 </div>
//               </div>

//               {/* Stay & verifier */}
//               <SectionTitle
//                 icon="ti ti-user-check"
//                 title="Stay & Verifier Details"
//               />

//               <div className="row g-4 mb-4">
//                 <div className="col-md-4 col-6">
//                   <InfoItem
//                     icon="ti ti-calendar-time"
//                     label="Period of Stay"
//                     value={
//                       address.period_of_stay
//                         ? `${address.period_of_stay} ${address.period_of_stay_param || ""}`
//                         : ""
//                     }
//                   />
//                 </div>
//                 <div className="col-md-4 col-6">
//                   <InfoItem
//                     icon="ti ti-home-check"
//                     label="Ownership Status"
//                     value={address.ownership_status}
//                   />
//                 </div>
//                 <div className="col-md-4 col-6">
//                   <InfoItem
//                     icon="ti ti-user"
//                     label="Verifier Name"
//                     value={address.verifier_full_name}
//                   />
//                 </div>
//                 <div className="col-md-4 col-6">
//                   <InfoItem
//                     icon="ti ti-users"
//                     label="Relationship"
//                     value={address.verifier_relationship}
//                   />
//                 </div>
//                 <div className="col-md-8">
//                   <InfoItem
//                     icon="ti ti-flag"
//                     label="Landmark"
//                     value={address.verifier_addrlandmark}
//                   />
//                 </div>
//               </div>

//               {/* Photos */}
//               <SectionTitle
//                 icon="ti ti-photo"
//                 title="Selfie & Uploaded Photos"
//               />

//               {photos.length > 0 ? (
//                 <div className="row g-3">
//                   {photos.map((photo) => (
//                     <div className="col-xl-3 col-lg-4 col-md-6" key={photo.key}>
//                       <div className="addr-photo-card">
//                         <div
//                           className="photo-wrap"
//                           onClick={() =>
//                             window.open(fileUrl(photo.url), "_blank")
//                           }
//                         >
//                           <img src={fileUrl(photo.url)} alt={photo.label} />
//                           <div className="photo-overlay">
//                             <i className="ti ti-eye"></i>
//                           </div>
//                         </div>

//                         <div className="p-3 d-flex justify-content-between align-items-center">
//                           <div className="d-flex align-items-center gap-2">
//                             <i
//                               className={photo.icon}
//                               style={{ color: "#E67E22" }}
//                             ></i>
//                             <span className="fw-semibold">{photo.label}</span>
//                           </div>

//                           {photo.key === "live_selfie_url" && (
//                             <span
//                               className={`badge ${
//                                 photo.verified
//                                   ? "bg-success-subtle text-success-emphasis border border-success-subtle"
//                                   : "bg-danger-subtle text-danger-emphasis border border-danger-subtle"
//                               }`}
//                             >
//                               <i
//                                 className={`ti ${
//                                   photo.verified ? "ti-circle-check" : "ti-x"
//                                 } me-1`}
//                               ></i>
//                               {photo.verified ? "Verified" : "Not Verified"}
//                             </span>
//                           )}
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <div className="text-muted">No photos uploaded.</div>
//               )}
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// export default AddressDetailsView;